
export const getRandomRadius = (max) =>  {
  let radius = Math.floor(Math.random() * max);
  return [radius, radius];
};

export const getRandomX = (max = 1) => {
  return `${Math.floor(Math.random() * max * 100)}%`;
}

export const getRandomY = (max = 1) => {
  return `${Math.floor(Math.random() * max * 100)}%`;
}

export const getRandomXDec = (max = 1) => {
  return Math.floor(Math.random() * max);
}

export const isEvenNumber = (number = 0) => {
  return number % 2 === 0;
}

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const isTabletOrLess = (width) => width <= 768;
export const isDesktopCustom = (width) => width > 1024;
export const isMobileCustom = (width) => width < 768;
